"use strict";

exports.__esModule = true;
exports.default = void 0;
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _mediaQueries = _interopRequireDefault(require("../shared/mediaQueries"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var HeroSection = /*#__PURE__*/
(0, _reactEmotion.default)('section', {
  target: "e1waf77w0"
})(function (props) {
  var _ref;
  return _ref = {
    background: props.background || 'transparent',
    minHeight: '100%',
    height: '100vh',
    padding: 50,
    display: 'flex',
    alignItems: 'center'
  }, _ref[(0, _mediaQueries.default)('md')] = {
    padding: '50px 25px',
    height: '100%'
  }, _ref;
});
var _default = HeroSection;
exports.default = _default;